import { lazy } from "react";

export const DoctorDetailsAsync = lazy(() => import("./DoctorDetails"));
